
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M21.785 8.077c.66 0 1.31.175 1.881.505l13.177 7.53a3.77 3.77 0 0 1 1.882 3.255v15.059a3.77 3.77 0 0 1-1.882 3.256l-4.882 2.789a10.65 10.65 0 0 0-8.594-7.563 6.09 6.09 0 1 0-3.644.069 10.66 10.66 0 0 0-8.196 7.448l-4.8-2.743a3.77 3.77 0 0 1-1.883-3.256V19.367a3.76 3.76 0 0 1 1.883-3.256l13.176-7.529a3.77 3.77 0 0 1 1.882-.505"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M40.94 28.013V16.471a3.76 3.76 0 0 0-1.882-3.257L25.882 5.685a3.76 3.76 0 0 0-3.764 0l-13.176 7.53A3.76 3.76 0 0 0 7.06 16.47v15.058a3.76 3.76 0 0 0 1.882 3.256l13.176 7.53c.572.33 1.221.504 1.882.504"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M23.652 30.327a6.09 6.09 0 1 0 0-12.18 6.09 6.09 0 0 0 0 12.18Z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M14.254 37.568a10.142 10.142 0 0 1 15.671-5.236M40.5 35.5h2.151c.47 0 .849.37.849.828v8.344c0 .458-.38.828-.849.828H30.348a.84.84 0 0 1-.848-.828v-8.344c0-.458.38-.828.849-.828H32.5m5.5 6h3m-3-2h3M36.5 43a2.3 2.3 0 0 0-.87-1.08 2.5 2.5 0 0 0-1.36-.42 2.5 2.5 0 0 0-1.372.388A2.3 2.3 0 0 0 32 42.946m3.3-6.446c-.442 0-.8-.336-.8-.75v-1.5c0-.414.358-.75.8-.75h2.4c.442 0 .8.336.8.75v1.5c0 .414-.358.75-.8.75zm.345 3.503a1.48 1.48 0 1 1-2.96 0 1.48 1.48 0 0 1 2.96 0Z"}})])
          )
        }
      }
    